import { IUrlInterceptor } from '../urlInterceptorTypes';

// 商城迁移KRN，实验处理
export const kwaiShopUrlHandle: IUrlInterceptor = async args => {
    const { url, params = {}, redirectUrl = {}, abRes = {} } = args;
    if (url.includes('/shop/c/kwai-shop-new')) {
        // 如果命中实验
        if (abRes.kisb_kwaishop_hit_krn?.value) {
            return {
                url,
                params: {
                    ...params,
                    hyId: 'kibt-fe-shop-c-krn',
                },
                redirectUrl: {
                    ...redirectUrl,
                    bundleId: 'EcommKwaiShop',
                    componentName: 'KwaiShop',
                },
                abRes,
            };
        }
    }
    return args;
};
